import React, { Suspense } from 'react';
import Page, { PageHeader, PageTitle } from 'components/Page';
import Button from 'packages/ui/Button';
import Loading from 'components/Loading';
import { Link } from 'react-router-dom';

const RefundsList = React.lazy(() => import('./Refunds'));

function Refunds(props) {
  return (
    <Page>
      <PageHeader>
        <PageTitle>لیست عودت‌ها</PageTitle>
        <Button as={Link} type="anchor" to="/refunds/new">
          ساخت برگشت پول
        </Button>
      </PageHeader>

      <Suspense fallback={<Loading />}>
        <RefundsList {...props} />
      </Suspense>
    </Page>
  );
}

export default Refunds;
